import { useQuery } from '@tanstack/react-query';
import { getAppointmentCancelAttributes } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useAppointmentCancelAttributesQuery = (params: {
  appointmentId: string;
  fromDatetime: string;
  seriesId?: string;
}, opts?: BaseQueryOpts) => {
  return useQuery([ 'appointment', params, 'cancelAttributes' ], async () => {
    const response = await getAppointmentCancelAttributes(params);

    return response.data;
  }, opts);
};
